// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__2MsSz","label":"style_label__1vNIt","textArea":"style_textArea__36CRW"};